module.exports = __webpack_public_path__ + "static/Artboard-3-e5e141cd24fc56105c3c3d4922ece9a3.png";